import {PromocodesServiceInterface} from "@/services/PromocodesService/PromocodesService.interface";
import {PromocodeGroupsServiceSchema} from "@/services/PromocodeGroupsService/PromocodeGroupsService.schema";

export const PromocodesServiceSchema: PromocodesServiceInterface = {
    id: null,
    hash: null,
    type: null,
    isEdit: false,
    isActive: false,
    groupId: null,
    promocodeGroup: PromocodeGroupsServiceSchema,
    autoUse: false,
    autoUseConsult: false,
    count: null,
    createdAt: null,
    deletedAt: null,
    event: {
        dateWithTimezone: null,
        eventId: null,
        eventTitle: null,
        id: null,
        state: null,
        tickets: [],
    },
    foreignEvents: [],
    eventId: null,
    isCertificate: false,
    links: {},
    maxsum: null,
    maxticket: null,
    minsum: null,
    minticket: null,
    promocode: null,
    size: null,
    typeId: null,
    unlimited: false,
    updatedAt: null,
    useOptions: true,
    used: null,
    from: null,
    till: null,
}
